<div class="modal-backdrop" *ngIf="isModalOpen">
  <div class="modal-content">
    <p>Complete your profile to proceed with login</p>
    <div class="d-flex justify-content-center">
      <div class="px-2"><button (click)="clickProceed()">Proceed</button></div>
      <div><button (click)="closeModal()">Close</button></div>
    </div>
  </div>
</div>

<div class="login-container" *ngIf="!isModalOpen">
  <h4>Sign In</h4>
  <p class="text">Welcome back! Please enter your details</p>
  <p *ngIf="errMessageBlocked" class="text blocked">
    {{ errMessageBlocked }}
  </p>
  <form [formGroup]="formdata" (ngSubmit)="login()">
    <!-- User Name -->
    <div class="form-group user">
      <label for="username ">Username</label>
      <input class="form-control shadow-none" type="text" placeholder="Username"
        (input)="onChnageInput($event, 'email')" formControlName="username" [ngClass]="{
          'is-invalid':
            (submit && form['username']?.errors) ||
            (form['username']?.invalid &&
              (form['username']?.dirty || form['username']?.touched)),
        }" />
      <div *ngIf="
          (submit && form['username']?.errors) ||
          (form['username']?.invalid &&
            (form['username']?.dirty || form['username']?.touched))
        " class="invalid-feedback">
        <span *ngIf="form['username'].errors?.['required']">Username is Required</span>
        <span *ngIf="form['username'].errors?.['minlength']">Minimum Length 2 Characters.</span>
        <span *ngIf="form['username'].errors?.['maxlength']">Maximum Length 50 Characters.</span>
        <!-- <span *ngIf="form['username'].errors?.['pattern']">
          Only letters, numbers & special character are allowed.
        </span> -->
      </div>
      <div *ngIf="errMessageEmail" class="text-danger">
        <span>{{ errMessageEmail }}</span>
      </div>
    </div>
    <div class="form-group" *ngIf="!forgotPassword">
      <label for="password">Password</label>
      <div class="input-group">
        <input class="form-control shadow-none" type="password" placeholder="Password" formControlName="password"
          (input)="onChnageInput($event, 'password')" [ngClass]="{
            'is-invalid':
              (submit && form['password'].errors) ||
              (form['password'].invalid &&
                (form['password'].dirty || form['password'].touched)),
          }" [type]="passwordFieldType" />
        <button class="input-group-text" (click)="togglePasswordVisibility()" type="button">
          <i [class]="
              passwordFieldType == 'password' ? 'fa fa-eye-slash' : 'fa fa-eye'
            "></i>
        </button>
        <div *ngIf="
            (submit && form['password']?.errors) ||
            (form['password']?.invalid &&
              (form['password']?.dirty || form['password']?.touched))
          " class="invalid-feedback">
          <p class="err_msg" *ngIf="form['password'].errors?.['required']">
            Password Required
          </p>
          <p class="err_msg" *ngIf="form['password'].errors?.['maxlength']">
            Maximum Length 64 Characters.
          </p>
          <!-- <p class="err_msg" *ngIf="form['password'].errors?.['pattern']">
            Only letters, numbers & special character are allowed.
          </p> -->
        </div>
      </div>
      <div *ngIf="errMessagePassword" class="text-danger">
        <span>{{ errMessagePassword }}</span>
      </div>
    </div>

    <!-- <div class="form-group" *ngIf="forgotPassword">
      <label for="dateofbirth">Date Of Birth</label>
      <input
        class="form-control shadow-none"
        type="date"
        formControlName="dateofbirth"
        [ngClass]="{
          'is-invalid':
            (submit && form['dateofbirth']?.errors) ||
            (form['dateofbirth']?.invalid &&
              (form['dateofbirth']?.dirty || form['dateofbirth']?.touched)),
        }"
      />
      <div
        *ngIf="
          (submit && form['dateofbirth']?.errors) ||
          (form['dateofbirth']?.invalid &&
            (form['dateofbirth']?.dirty || form['dateofbirth']?.touched))
        "
        class="invalid-feedback"
      >
        <span *ngIf="form['dateofbirth'].errors?.['required']"
          >Date Of Birth Required</span
        >
      </div>
    </div> -->
    <div>
      <button class="btn submit w-100 m-0">{{forgotPassword ? 'Send Mail' : 'Login'}}</button>
    </div>
    <!-- <div *ngIf="!forgotPassword" class="mt-3">
      <button type="button" class="btn btn-outline-primary w-100 m-0 p-2" style="border-radius: 4px; font-weight: 500;" (click)="loginSSO(); $event.preventDefault()">Login with SSO</button>
    </div> -->
    <div class="text-end mt-2">
      <a *ngIf="!forgotPassword" href="#" (click)="forgotPass(this.formdata.get('username')?.value)">Forgot
        Password?</a>
      <a *ngIf="forgotPassword" href="#" (click)="forgotPass(this.formdata.get('username')?.value)">Back</a>
    </div>
  </form>
</div>

<div class="details-container" *ngIf="!isModalOpen">
  <div class="details">
    <div class="card">Business</div>
    <h1>
      Everything You Need to Manage Your Workforce,<br />
      <span>- All in One Place</span>
    </h1>
    <div class="description">
      Manage employee records, track attendance, process payroll, streamline
      recruitment, communication with team members, build a digital HR presence,
      and enhance efficiency with powerful, easy-to-use tools.
    </div>
  </div>
</div>